module.exports = __webpack_public_path__ + "static/media/iconeprelevement.610828be.png";